<template>
    <div id="app"> 
		<router-view/> 
    </div>
</template>
<script> 
export default{
	// components: { pageIndex,  },
	name:'App',
	mounted(){

	}
 }
</script>

<style scoped>
  
#app {
	width:100%;
	height: 100%;
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
